import { adminOutletKey } from './adminOutletKey';

const LS_KEY = 'wp:nav-debug';

export function isAdminNavDebugEnabled(): boolean {
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem(LS_KEY) === '1';
  } catch {
    return false;
  }
}

/** Dev only. Enable: `localStorage.setItem('wp:nav-debug','1')`. */
export function logAdminNavTransition(from: string, to: string) {
  if (!isAdminNavDebugEnabled()) return;
  const fromKey = adminOutletKey(from);
  const toKey = adminOutletKey(to);
  const sameOutletKey = fromKey === toKey;
  const t0 = performance.now();
  // eslint-disable-next-line no-console
  console.info('[wp-nav]', {
    from,
    to,
    fromKey,
    toKey,
    sameOutletKey,
    outletRemount: !sameOutletKey,
    t0,
  });
  performance.mark(`wp-nav:${to}`);
  requestAnimationFrame(() => {
    // eslint-disable-next-line no-console
    console.info('[wp-nav] rAF after route', { to, ms: Math.round(performance.now() - t0) });
  });
  queueMicrotask(() => {
    // eslint-disable-next-line no-console
    console.info('[wp-nav] microtask after route', { to, ms: Math.round(performance.now() - t0) });
  });
  window.setTimeout(() => {
    // eslint-disable-next-line no-console
    console.info('[wp-nav] +50ms after route', { to, ms: Math.round(performance.now() - t0) });
  }, 50);
  window.setTimeout(() => {
    // eslint-disable-next-line no-console
    console.info('[wp-nav] +500ms after route', { to, ms: Math.round(performance.now() - t0) });
  }, 500);
}
